export function getBaseURL() {
    // 检查环境变量是否存在并且有效
    const nodeEnv = process.env.REACT_APP_NODE_ENV?.trim();
    
    if (nodeEnv === 'production') {
        return 'api.galaxymentor.com';
    } else {
        return 'localhost:8080';
    }
}

// 获取默认的baseURL
const baseURL = getBaseURL();

export default baseURL;